import React from 'react'
import Style from '../StoreMenu/StoreMenu.module.css'
import PointSpreadLoading from 'react-loadingg/lib/PointSpreadLoading';
const StoreMenuSupermarket = (props) => {
   let loading=null

    if(props.products===undefined){
        loading=<div className={Style.SetLoading}>
                    <PointSpreadLoading  color={'#ab0c59'} size={"small"} />
            </div>
    }
    else{
        loading=
        props.products.map((item)=>{
            return(
                <li key={item.id} onClick={()=>props.filterProduct(item.category_english)}>
                    {item.category_persian}
                </li> 
            )
        })
    }
    return (
        
        <div className={Style.fixList}>
            <ul className={Style.ListHolder}>
                {
                loading
                }
            </ul>
        </div>
    )
}
export default StoreMenuSupermarket
